import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { countOnce } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useCopy } from "./HelpersUI";

// Email capture that captures nothing: no player, no email, nothing stored or sent — only an anonymous count.
export function JoinModal({ open, onClose, title }) {
  const { c } = useCopy();
  const [phase, setPhase] = useState("form");  // form → done → glitch → done
  const [email, setEmail] = useState("");
  const timers = useRef([]);
  useEffect(() => () => timers.current.forEach(clearTimeout), []);
  useEffect(() => { if (!open) { timers.current.forEach(clearTimeout); setPhase("form"); setEmail(""); } }, [open]);
  const submit = (e) => {
    e.preventDefault();
    setEmail("");
    setPhase("done");
    countOnce("helpers_join");
    const calm = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    timers.current.push(setTimeout(() => setPhase("glitch"), 2000), setTimeout(() => setPhase("done"), calm ? 3400 : 2900));
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="helpers-join-modal" className="h-site w-[calc(100%-2rem)] max-w-md rounded-[2rem] border-0 bg-white p-8 shadow-2xl sm:rounded-[2rem] [&>button:last-child]:hidden">
        <button type="button" onClick={onClose} data-testid="helpers-join-close" aria-label="Close"
          className="absolute right-5 top-5 rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"><X size={18} /></button>
        {phase === "form" ? (
          <form onSubmit={submit} data-testid="helpers-join-form">
            <DialogTitle className="h-display text-2xl font-bold text-[color:var(--h-ink)]">{title || c.modal_title}</DialogTitle>
            <DialogDescription className="mt-2 text-[15px] leading-relaxed text-slate-600">{c.modal_body}</DialogDescription>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" autoComplete="off"
              data-testid="helpers-join-email" aria-label="Email address"
              className="mt-6 w-full rounded-2xl border border-[color:var(--h-line)] bg-[color:var(--h-bg)] px-5 py-4 text-base outline-none transition-shadow focus:shadow-[0_0_0_4px_rgba(31,138,100,.15)]" />
            <button type="submit" data-testid="helpers-join-submit"
              className="h-btn mt-4 w-full rounded-full bg-[color:var(--h-mint-deep)] py-4 font-semibold text-white hover:bg-[color:var(--h-mint-ink)]">{c.modal_button}</button>
          </form>
        ) : (
          <div className="py-8 text-center" data-testid="helpers-join-confirmation">
            <DialogTitle className="sr-only">{c.modal_done}</DialogTitle>
            {phase === "glitch"
              ? <p data-testid="helpers-join-crack" className="h-crack font-mono text-2xl text-[#ffb000]" data-text={c.modal_crack}>{c.modal_crack}</p>
              : <p data-testid="helpers-join-done" className="h-display text-3xl font-bold text-[color:var(--h-mint-deep)]">{c.modal_done}</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
